import Tabs from './libs/tabs';
import Stepper from './libs/stepper';
import RadioTabs from './libs/radio_tabs';
import Wizard from './libs/wizard';

import i18n from './i18n/fr';
import datas from './datas/_datas';
import compute from './datas/_compute_rules';
import * as charts from './datas/_charts_config';
import example from './datas/_example_simulation';

import { capitalizeFirstLetter } from './helpers/string_helper';
import { addClass, hasClass, removeClass, toggleClass } from './helpers/class_helper';
import { toFloat } from './helpers/math_helper';
import { populateOptions } from './helpers/select_helper';
import { validateField, validateFields } from './helpers/validations_helper';
import { allowNumericOnly, setInputValue, removeError } from './helpers/input_helper';
import { isLeftMouseClick , addClickEventListener } from './helpers/event_helper';
import { scrollTo, scrollToIfNotVisible } from './helpers/animations_helper';
import { createPdf } from './pdf_report';
import * as HighchartsExporting from 'highcharts/modules/exporting';
import * as HighchartsOfflineExporting from 'highcharts/modules/offline-exporting';


/*
  Code conventions :
    variables follow the normal convention : variableName
    functions follow the normal convention : functionName
    datas keys                             : data_non_computed
    translation keys                       : translated_word
    html id                                : an-identifiant
    css class                              : a-class
    optional variable                      : _privateVar
*/

/*
  Be aware that ES6 arrow function differ from classic javascript function in
  that it doesn't have prototype and 'de facto' no context (no this).
*/

$(document).foundation();


//TODO: Need some refactoring and file division !
document.addEventListener("DOMContentLoaded", () => {


//------------------------------------------------------------------------------
//  VARIABLES
//------------------------------------------------------------------------------

  const t = i18n[window.locale];

  // GENERAL
  const loadingDimmer       = document.getElementById('loading-dimmer');
  const partnerLogos = {
    iera               : document.getElementById('logo-iera'),
    hespul             : document.getElementById('hespul-link'),
    auvergneRhoneAlpes : document.getElementById('region-auvergne-rhone-alpes-link'),
    ademe              : document.getElementById('ademe-link'),
    europe             : document.getElementById('europe-link'),
  };


  // Help modal
  const $modalHelp           = $('#modal-help');
  const exampleSimulationBtn = document.getElementById('example-simulation');


  // Estimate needs modal
  const $modalEstimateNeeds      = $('#modal-estimate-needs');
  const modalEstimateNeedsAnchor = document.getElementById('modal-estimate-needs').parentElement;
  const estimateNeedsFields = {
    livingAreaInput              : document.getElementById('living-area'),
    inhabitantsInput             : document.getElementById('inhabitants'),
    invoicesTextArea             : document.getElementById('invoices'),
    buildingYearsSelect          : document.getElementById('building-years'),
    energyVectorsSelect          : document.getElementById('energy-vector'),
    consumptionInput             : document.getElementById('consumption'),
    currentHeatingSystemSelect   : document.getElementById('current-heating-system'),
    currentHotWaterSystemSelect  : document.getElementById('current-hot-water-system'),
  };
  const energyVectorUnit         = estimateNeedsFields.consumptionInput.parentNode.querySelector('.input-group-label');

  const estimateMyNeedsSection   = document.getElementById('estimate-my-needs');
  const estimateFromSection      = document.getElementById('estimate-from');
  const computeEstimationBtn     = document.getElementById('compute-estimation');
  const estimationResults        = document.getElementById('estimation-results');
  const heatingComputedNeeds     = document.getElementById('heating-computed-needs');
  const hotWaterComputedNeeds    = document.getElementById('hot-water-computed-needs');
  const validateInformationsBtn  = document.getElementById('validate-informations');


  // SOLUTIONS
  const nbMaxSolutions          = document.getElementById('nb-simulations').value;

  const heatingSolutionsTitle   = document.getElementById('heating-solutions-title');
  const needs = {
    estimatedHeatingNeedsInput  : document.getElementById('estimated-heating-needs'),
    estimatedHotWaterNeedsInput : document.getElementById('estimated-hot-water-needs'),
    heatingNeedsInput           : document.getElementById('heating-needs'),
    hotWaterNeedsInput          : document.getElementById('hot-water-needs'),
  };
  const oldHotWaterNeedsInput   = document.getElementById('old-hot-water-needs');

  let solutions = [];
  for (let i=1; i <= nbMaxSolutions; i++) {
    solutions.push({
      consideredHeatingSystemSelect     : document.getElementById('considered-heating-system-' + i),
      heatingEnergyTypeInput            : document.getElementById('heating-energy-type-' + i),
      heatingGreenEnergyCheckbox        : document.getElementById('heating-green-energy-' + i),
      heatingEstimatedInvestmentInput   : document.getElementById('heating-estimated-investment-' + i),
      heatingEfficiencyInput            : document.getElementById('heating-efficiency-' + i),
      heatingMaintenanceInput           : document.getElementById('heating-maintenance-' + i),
      heatingEnergyPriceInput           : document.getElementById('heating-energy-price-' + i),
      heatingEnergyPriceTooltip         : $('#heating-energy-price-' + i).closest('label').children('.has-tip'),
      heatingEnergyPriceVariationInput  : document.getElementById('heating-energy-price-variation-' + i),
      consideredHotWaterSystemSelect    : document.getElementById('considered-hot-water-system-' + i),
      hotWaterEnergyTypeInput           : document.getElementById('hot-water-energy-type-' + i),
      hotWaterGreenEnergyCheckbox       : document.getElementById('hot-water-green-energy-' + i),
      hotWaterEstimatedInvestmentInput  : document.getElementById('hot-water-estimated-investment-' + i),
      hotWaterEfficiencyInput           : document.getElementById('hot-water-efficiency-' + i),
      hotWaterMaintenanceInput          : document.getElementById('hot-water-maintenance-' + i),
      hotWaterEnergyPriceInput          : document.getElementById('hot-water-energy-price-' + i),
      hotWaterEnergyPriceTooltip        : $('#hot-water-energy-price-' + i).closest('label').children('.has-tip'),
      hotWaterEnergyPriceVariationInput : document.getElementById('hot-water-energy-price-variation-' + i),
      solarSystemSelect                 : document.getElementById('solar-system-' + i),
      solarPanelSurfaceInput            : document.getElementById('solar-panel-surface-' + i),
      solarEstimatedInvestmentInput     : document.getElementById('solar-estimated-investment-' + i),
    });
  }

  const heatingFurtherFieldNames = [
    'heatingGreenEnergyCheckbox',
    'heatingEstimatedInvestmentInput',
    'heatingEfficiencyInput',
    'heatingMaintenanceInput',
    'heatingEnergyPriceInput',
    'heatingEnergyPriceVariationInput'
  ];
  const hotWaterFurtherFieldNames = [
    'hotWaterGreenEnergyCheckbox',
    'hotWaterEstimatedInvestmentInput',
    'hotWaterEfficiencyInput',
    'hotWaterMaintenanceInput',
    'hotWaterEnergyPriceInput',
    'hotWaterEnergyPriceVariationInput'
  ];
  const solarFurtherFieldNames = ['solarPanelSurfaceInput', 'solarEstimatedInvestmentInput'];

  const cancelSolutionBtn   = document.getElementById('cancel-solution');
  const resetSolutionBtn    = document.getElementById('reset-solution');
  const prevSolutionBtn     = document.getElementById('prev-solution');
  const nextSolutionBtn     = document.getElementById('next-solution');
  const compareSolutionsBtn = document.getElementById('compare-solutions');

  // RESULTS
  const flipCards = document.getElementsByClassName('flip-card-container');
  const scenarii  = ['trend', 'custom', 'crysis'];
  let pdfLinks    = {};
  scenarii.forEach( scenario => {
    pdfLinks[scenario] = document.getElementById(scenario + '-pdf-link');
  });


  //----------------------------------------------------------------------------
  //  GENERAL ELEMENTS
  //----------------------------------------------------------------------------

  $('.has-tip').tooltipster({
    contentAsHTML : true,
    iconDesktop   : true,
    onlyOne       : true,
    interactive   : true,
    autoClose     : false,
    maxWidth      : '300',
    animation     : 'grow',
    theme         : ['tooltipster-light', 'tooltipster-light-custom'],
  });

  $('.button-tip').tooltipster({
    iconDesktop : true,
    onlyOne     : true,
    interactive : true,
    autoClose   : false,
    maxWidth    : '300',
    animation   : 'grow',
    theme       : ['tooltipster-light', 'tooltipster-light-custom'],
  });

  function showLoadingDimmer(visible, text='') {
    if (visible) {
      loadingDimmer.querySelector('.text').innerHTML = text;
      document.documentElement.style.height   = '100%';
      document.documentElement.style.overflow = 'hidden';
      addClass(loadingDimmer, 'visible');
    } else {
      document.documentElement.style.height   = 'unset';
      document.documentElement.style.overflow = 'auto';
      removeClass(loadingDimmer, 'visible');
      loadingDimmer.querySelector('.text').innerHTML = text;
    }
  }

  addClickEventListener(loadingDimmer, function(event) {});

  addClickEventListener(exampleSimulationBtn, function(event) {
    populateWithExampleSimulation();
    $modalHelp.foundation('close');
  });


  //----------------------------------------------------------------------------
  //  INITIALIZE
  //----------------------------------------------------------------------------

  estimateNeedsFields.livingAreaInput.focus();

  // Initialize main stepper (Mon habitation -> Simulation de chauffage -> Résultats)
  const mainSteps = new Stepper('.js-main-step', '.js-main-step-content', {
    dataAttr: 'data-step-id',
    beforeClickCallback: function(tab) {
      const tabId = tab.getAttribute('data-step-id');
      if (tabId == "results") {
        if (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput]) && validateSolution(solutionsWizard.getSelectedIndex())) {
          showLoadingDimmer(true, t.dimmer.computing);
          let done = false;
          // Avoid weird javascript's behaviour which execute page transition before end of results computing
          setTimeout( () => {
            computeScenariiResults();
            resetFlippedCards();
            setResultActiveScenarioTab();
            showLoadingDimmer(false);
            mainSteps.activate('results', {
              after: () => {
                scrollTo(document.querySelector('header').getBoundingClientRect().top);
              }
            });
          }, 30);
          return false;
        } else {
          scrollToIfNotVisible(document.querySelector('#simulations .is-invalid-label').getBoundingClientRect().top);
          return false;
        }
      } else
        return true;
    },
    afterClickCallback: function(tabId) {
      if (tabId == "results")
        scrollTo(document.querySelector('header').getBoundingClientRect().top);
      return true;
    },
  });

  // Disable event propagation to label when clicking on help icon to avoid focus input without opening tooltip
  [].forEach.call(document.getElementsByClassName('has-tip'), element => {
    element.addEventListener('click', event => {
      event.preventDefault();
    });
    element.addEventListener('ontouchstart', event => {
      event.preventDefault();
    });
  });

  document.addEventListener('keypress', function(event) {
    if (event.which == 13 || event.keyCode == 13) {
      if (modalEstimateNeedsAnchor.style.display == 'block') {
        estimateMyNeeds();
        // if (!hasClass(estimationResults, 'is-hidden'))
        //   validAndCloseModalEstimateNeeds();
      } else if (mainSteps.getSelectedIndex() == 0) {
        const activeStep = solutionsWizard.getSelectedIndex();
        if (solutions[activeStep]['solarPanelSurfaceInput'] !== document.activeElement) {
          const activeElement = document.activeElement;

          if (activeElement instanceof HTMLInputElement)
            activeElement.dispatchEvent(new Event('blur')); // send blur event if it's furher field that has focus

          const nbActiveSolutions = solutionsWizard.getNbActiveTabs();
          if (!['heating-needs', 'hot-water-needs'].includes(document.activeElement.id)) {
            (nbActiveSolutions >= 2 && activeStep === nbActiveSolutions-1)
              ? compareSolutions()
              : goToNextSolution();
          }
        } else {
          setTimeout(function() { solutions[activeStep]['solarEstimatedInvestmentInput'].focus() }, 10);
        }
      }
    }
  });



//================================================================================
//                             ESTIMATE NEEDS
//================================================================================


  allowNumericOnly(estimateNeedsFields.invoicesTextArea);

  // Initialize estimation tabs [invoices, building-years, consumption]
  const estimateFromRadioTabs = new RadioTabs('.js-radio-filter', '.js-estimate-from-panel', {
    dataAttr: 'data-radio-tab-id',
    beforeCallback: () => { // using classic function for callback because arrow function doesn't have prototype
      // Need to force the user to click the button to recalculate his estimation when he change is 'estimate_from'
      addClass(estimationResults, 'is-hidden');
      return true;
    },
    afterCallback: function() { // using classic function for callback because arrow function doesn't have prototype
      const hiddenPanels = estimateFromSection.querySelectorAll('.js-estimate-from-panel:not(.active)');
      hiddenPanels.forEach( hiddenPanel => {
        const invalidFields = hiddenPanel.querySelectorAll('.is-invalid-label');
        invalidFields.forEach( invalidField => {
          removeError(invalidField);
        });
      });

      const estimationFrom = estimateFromSection.querySelector('.js-estimate-from-panel.active').getAttribute('data-radio-tab-id');
      let currentSystemSelects = [
        estimateNeedsFields.currentHeatingSystemSelect,
        estimateNeedsFields.currentHotWaterSystemSelect,
      ];
      currentSystemSelects.forEach( currenSystemSelect => {
        const currenSystemSelectLabel = currenSystemSelect.closest('label');
        currenSystemSelect.value = '';
        removeError(currenSystemSelect.closest('label'));
        (estimationFrom === 'estimate-from-building_years')
          ? addClass(currenSystemSelectLabel, 'is-hidden')
          : removeClass(currenSystemSelectLabel, 'is-hidden');
      })
      addClass(estimationResults, 'is-hidden');
    },
  });


  //----------------------------------------------------------------------------
  //  SELECTS
  //----------------------------------------------------------------------------

  const currentHeatingSystemOptions = datas.heating_systems.map( element => {
    return {
      value : element.id,
      label : t.datas.heating_systems[element.identifier].long,
    };
  });

  // Populate the Select depending on their HTML name attribute
  populateOptions(estimateNeedsFields.currentHeatingSystemSelect, currentHeatingSystemOptions, {
    placeholder : t.select.current_heating_system.placeholder,
  });

  const currentHotWaterSystemOptions = datas.hot_water_systems.map( element => {
    element.id
    return {
      value : element.id,
      label : t.datas.hot_water_systems[element.identifier].long,
    };
  });
  populateOptions(estimateNeedsFields.currentHotWaterSystemSelect, currentHotWaterSystemOptions, {
    placeholder : t.select.current_hot_water_system.placeholder,
    empty       : t.select.current_hot_water_system.empty,
  });

  const buildingYearsOptions = datas.building_years.map( element => {
    return {
      value : element.id,
      label : t.datas.building_years[element.identifier],
    };
  })
  populateOptions(estimateNeedsFields.buildingYearsSelect, buildingYearsOptions);

  const energyVectorOptions = datas.energy_vectors.map( element => {
    return {
      value : element.id,
      label : t.datas.energy_vectors[element.identifier].label,
    };
  })
  populateOptions(estimateNeedsFields.energyVectorsSelect, energyVectorOptions);


//------------------------------------------------------------------------------
//  FUNCTIONS
//------------------------------------------------------------------------------

  function initEstimateMyNeedsSection() {
    [ estimateNeedsFields.invoicesTextArea,
      estimateNeedsFields.consumptionInput,
      estimateNeedsFields.currentHeatingSystemSelect,
      estimateNeedsFields.currentHotWaterSystemSelect
    ].forEach( select => {
      select.value = '';
    });
    [ estimateNeedsFields.buildingYearsSelect,
      estimateNeedsFields.energyVectorsSelect
    ].forEach( select => {
      select.selectedIndex = 0;
    });
    estimateFromRadioTabs.activate('estimate-from-invoices');
    [ estimateNeedsFields.invoicesTextArea,
      estimateNeedsFields.energyVectorsSelect,
      estimateNeedsFields.consumptionInput,
      estimateNeedsFields.buildingYearsSelect,
      estimateNeedsFields.currentHeatingSystemSelect,
      estimateNeedsFields.currentHotWaterSystemSelect
    ].forEach( element => {
      removeError(element.closest('label'));
    });
    addClass(estimateMyNeedsSection, 'is-hidden');
  }

  function getEstimateNeedsFieldsToValidate() {
    const estimationFrom = estimateFromRadioTabs.getSelected().tab.value;
    let fieldsToValidate = [
      estimateNeedsFields.livingAreaInput,
      estimateNeedsFields.inhabitantsInput,
    ];

    switch (estimationFrom) {
      case 'invoices':
        fieldsToValidate.push(estimateNeedsFields.invoicesTextArea);
        fieldsToValidate.push(estimateNeedsFields.currentHeatingSystemSelect);
        fieldsToValidate.push(estimateNeedsFields.currentHotWaterSystemSelect);
        break;
      case 'building_years':
        fieldsToValidate.push(estimateNeedsFields.buildingYearsSelect);
        break;
      case 'consumption':
        fieldsToValidate.push(estimateNeedsFields.consumptionInput);
        fieldsToValidate.push(estimateNeedsFields.consumptionInput);
        fieldsToValidate.push(estimateNeedsFields.currentHeatingSystemSelect);
        fieldsToValidate.push(estimateNeedsFields.currentHotWaterSystemSelect);
        break;
      default:
    }
    return {
      estimationFrom   : estimationFrom,
      fieldsToValidate : fieldsToValidate,
    }
  }

  function estimateMyNeeds() {
    const {estimationFrom, fieldsToValidate} = getEstimateNeedsFieldsToValidate();
    if (validateFields(fieldsToValidate)) {
      populateEstimationResults(estimationFrom);
      removeClass(estimationResults, 'is-hidden');
      addClass(computeEstimationBtn, 'bt-active');
      scrollTo(estimationResults.getBoundingClientRect().top, modalEstimateNeedsAnchor);
    } else {
      // Scroll to the first error
      scrollToIfNotVisible(document.querySelector('#modal-estimate-needs .is-invalid-label').getBoundingClientRect().top, modalEstimateNeedsAnchor);
      addClass(estimationResults, 'is-hidden');
      removeClass(computeEstimationBtn, 'bt-active');
    }
  }

  function computeEstimations(estimationFrom) {
    let invoicesAmount = estimateNeedsFields.invoicesTextArea.value.trim().split(/\s/g).reduce( (sum, invoiceAmount) => {
      return sum + toFloat(invoiceAmount);
    }, 0);

    const values = {
      livingArea              : toFloat(estimateNeedsFields.livingAreaInput.value),
      inhabitants             : toFloat(estimateNeedsFields.inhabitantsInput.value),
      invoicesAmount          : invoicesAmount,
      buildingYearsId         : estimateNeedsFields.buildingYearsSelect.value,
      energyVectorId          : estimateNeedsFields.energyVectorsSelect.value,
      consumption             : toFloat(consumption.value),
      currentHeatingSystemId  : estimateNeedsFields.currentHeatingSystemSelect.value,
      currentHotWaterSystemId : estimateNeedsFields.currentHotWaterSystemSelect.value,
    }

    return compute.estimations_from[estimationFrom](values);
  };

  function populateEstimationResults(estimationFrom) {
    let { heatingNeeds, hotWaterNeeds } = computeEstimations(estimationFrom);
    heatingNeeds  = parseInt(heatingNeeds);
    hotWaterNeeds = parseInt(hotWaterNeeds);
    needs.estimatedHeatingNeedsInput.value   = heatingNeeds;
    needs.estimatedHotWaterNeedsInput.value  = hotWaterNeeds;
    heatingComputedNeeds.innerHTML  = heatingNeeds + '&nbsp;' + t.datas.units.kwh_by_years;
    hotWaterComputedNeeds.innerHTML = hotWaterNeeds + '&nbsp;' + t.datas.units.kwh_by_years;
  }

  function validAndPopulateEstimatedNeeds() {
    needs.heatingNeedsInput.value   = needs.estimatedHeatingNeedsInput.value;
    needs.hotWaterNeedsInput.value  = needs.estimatedHotWaterNeedsInput.value;
    inputListeners.needs(needs.heatingNeedsInput);
    inputListeners.needs(needs.hotWaterNeedsInput);
    removeError(needs.heatingNeedsInput.parentElement.parentElement);
    removeError(needs.hotWaterNeedsInput.parentElement.parentElement);
  }


  //----------------------------------------------------------------------------
  //  LISTENERS
  //----------------------------------------------------------------------------

  $modalEstimateNeeds.on('open.zf.reveal', function(event) {
    estimateNeedsFields.livingAreaInput.focus();
  });

  Object.keys(estimateNeedsFields).forEach( homeFieldKey => {
    estimateNeedsFields[homeFieldKey].addEventListener('change', function(event) {
      (validateField(this) && !hasClass(estimationResults, 'is-hidden'))
        ? populateEstimationResults(estimateFromRadioTabs.getSelected().tab.value)
        : removeClass(computeEstimationBtn, 'bt-active');
    });
  });

  // Change the units label of consumptionInput when an other consumptionType is selected
  estimateNeedsFields.energyVectorsSelect.addEventListener('change', event => {
    selectListeners.energyVector();
  });

  addClickEventListener(computeEstimationBtn, estimateMyNeeds);


  //----------------------------------------------------------------------------
  //  SUBMIT BUTTONS
  //----------------------------------------------------------------------------

  addClickEventListener(validateInformationsBtn, function(event) {
    validAndPopulateEstimatedNeeds();
    $modalEstimateNeeds.foundation('close');
    scrollTo(document.querySelector('header').getBoundingClientRect().top);
  });



//==============================================================================
//                              SIMULATIONS
//==============================================================================


  //----------------------------------------------------------------------------
  //  SELECTS
  //----------------------------------------------------------------------------

  function populateHotWaterSystemSelect(solution) {
    const withoutNone = (needs.hotWaterNeedsInput.value !== '0');
    const consideredHotWaterSystemOptions = datas.hot_water_systems.filter( hot_water => {
      return (hot_water.id == -1 && withoutNone) ? false : hot_water;
    }).map( element => {
      return {
        value : element.id,
        label : t.datas.hot_water_systems[element.identifier].long,
      };
    });

    populateOptions(solution.consideredHotWaterSystemSelect, consideredHotWaterSystemOptions, {
      placeholder : t.select.considered_hot_water_system.placeholder,
      empty       : t.select.current_hot_water_system.empty,
    });
  }

  const consideredHeatingSystemOptions = datas.heating_systems.map( element => {
    return {
      value : element.id,
      label : t.datas.heating_systems[element.identifier].long,
    };
  })

  const consideredSolarSystemOptions = datas.solar_systems.map( element => {
    return {
      value : element.id,
      label : t.datas.solar_systems[element.identifier].long,
    };
  })

  solutions.forEach( solution => {
    populateOptions(solution.consideredHeatingSystemSelect, consideredHeatingSystemOptions, {
      placeholder : t.select.considered_heating_system.placeholder,
    });

    populateHotWaterSystemSelect(solution);

    populateOptions(solution.solarSystemSelect, consideredSolarSystemOptions, {
      empty : t.select.solar_system.empty,
    });
  });


  //----------------------------------------------------------------------------
  //  FUNCTIONS
  //----------------------------------------------------------------------------

  /**
   * Counts the number of error(s) contained in the solution
   * @param {hash} solution : solution's list of inputs
   */
  function getSolutionNbErrors(solution) {
    let nbErrors = 0;
    getSolutionFields(solution).forEach(field => {
      if (hasClass(field, 'is-invalid-input')) nbErrors++;
    });
    return nbErrors;
  }

  /**
   * Check if the given solution has errors. If true, it update the corresponding
   *  wizard tab with the number of error(s)
   * @param {integer} solutionIndex : solution index (0 for the first)
   * @param {hash}    solution      : solution's list of inputs
   */
  function checkSolutionErrors(solutionIndex) {
    const solution        = solutions[solutionIndex];
    const solutionTab     = solutionsWizard.getTabs()[solutionIndex];
    const nbErrors        = getSolutionNbErrors(solution);
    const solutionTabLi   = solutionTab.parentElement;
    const nbErrorsElement = solutionTabLi.querySelector('.nb-errors');

    if (nbErrors > 0) {
      addClass(solutionTabLi, 'with-errors');
      if (nbErrorsElement) {
        nbErrorsElement.innerHTML = t.nb_errors(nbErrors)
      } else {
        const newContent     = document.createElement('div');
        newContent.className = 'nb-errors';
        newContent.innerHTML = t.nb_errors(nbErrors);
        // Don't use innerHTML to change DOM content because all child event handler will be destroyed
        // https://stackoverflow.com/questions/595808/is-it-possible-to-append-to-innerhtml-without-destroying-descendants-event-list
        solutionTabLi.appendChild(newContent);
      }
    } else {
      removeClass(solutionTabLi, 'with-errors');
      if (nbErrorsElement)
        solutionTabLi.removeChild(nbErrorsElement);
    }
    solutionsWizard.setTabs('.js-wizard-tab');
  }

  function setGreenElectricityData(solutionIndex, system) {
    const solution    = solutions[solutionIndex];
    const otherSystem = (system == 'heating')
      ? 'hotWater'
      : 'heating';
    let energyInputs = [
      solution[system + 'EnergyPriceInput'],
      solution[system + 'EnergyPriceVariationInput']
    ];

    if (solution[otherSystem + 'EnergyTypeInput'].value == 'electricity') {
      energyInputs = energyInputs.concat([
        solution[otherSystem + 'EnergyPriceInput'],
        solution[otherSystem + 'EnergyPriceVariationInput']
      ]);
    }

    if (solution[system + 'GreenEnergyCheckbox'].checked) {
      energyInputs.forEach( input => {
        // we associate custom value of other system to current system if valid
        input.value        = '';
        input.defaultValue = '';
      })
    } else {
      const computedEnergyInfos = computeSolutionEnergies(solution);
      setSolutionEnergyInfos(solution, computedEnergyInfos);
      energyInputs.forEach( input => {
        validateField(input);
        checkCustomValue(input);
      })
    }
    checkSolutionErrors(solutionIndex);
  }

  /**
   * Compute systems energy data (price and price variation) depending on needs and
   *  other energy dependencies (efficiency, price, price variation)
   *
   * @param  {hash} solution : solution's list of inputs
   * @return {hash}
   */
  function computeSolutionEnergies(solution) {
    const values = getSolutionValues(solution);
    return compute.solution.energies(values);
  }

  function setSolutionEnergyInfos(solution, data) {
    ['heating', 'hotWater'].forEach( system => {
      if (data[system])
        setSystemEnergyInfos(solution, system, data[system]);
    });
  }

  /**
   * Set system's energy further infos inputs depending on which data is provided
   *
   * @param  {hash}   solution : solution's list of inputs
   * @param  {string} system   : name of the system [heating, hotWater]
   * @param  {hash}   data     : data provided
   * @return {null}
   */
  function setSystemEnergyInfos(solution, system, data) {
    ['efficiency', 'energyPrice', 'energyPriceVariation'].forEach( furtherInfoName => {
      let furherInfoDefaultValue = data[furtherInfoName];

      if (furherInfoDefaultValue) {
        if (['efficiency', 'energyPriceVariation'].includes(furtherInfoName))
          furherInfoDefaultValue *= 100;

        const furtherInfoValue = (data['custom' + capitalizeFirstLetter(furtherInfoName)])
          ? data['custom' + capitalizeFirstLetter(furtherInfoName)]
          : furherInfoDefaultValue;

        const furtherInfoInput = solution[system + capitalizeFirstLetter(furtherInfoName) + 'Input'];

        furtherInfoInput.value        = toFloat(furtherInfoValue, 2);
        furtherInfoInput.defaultValue = (['energyPrice', 'energyPriceVariation'].includes(furtherInfoName) && data.greenEnergy && data.energyType.identifier == 'electricity')
          ? ''
          : toFloat(furherInfoDefaultValue, 2);
        checkCustomValue(furtherInfoInput);
      }
    });
    solution[system + 'EnergyPriceTooltip'].tooltipster('content', t.tooltip.energy_price);
  }

  /**
   * Dummy propagatation of custom energy data [price, priceVariation]
   *
   * @param {hash}       solution   : current active solution
   * @param {string}     system     : system in which the user modify an input
   * @param {DOMElement} input      : input modified by the user
   * @param {string}     energyType : energyType of the system
   */
  function propagateEnergyData(solution, system, input, energyType) {
    const otherSystem = (system == 'heating')
      ? 'hotWater'
      : 'heating';
    if (input.value.trim() == '') { // Reset to defaultValue (empty for green electricity) and propagate
      input.value = (energyType == 'electricity' && solution[system + 'GreenEnergyCheckbox'].checked)
        ? ''
        : input.defaultValue;
      // propagate
      (/-energy-price-variation/i.test(input.id))
        ? setNewEnergyData(solution, otherSystem, 'PriceVariation', input.value, energyType)
        : setNewEnergyData(solution, otherSystem, 'Price', input.value, energyType);
    } else { // propagate new value to system using the same energy vector
      if (validateField(input) && energyType != '')
        (/-energy-price-variation-/i.test(input.id))
          ? setNewEnergyData(solution, otherSystem, 'PriceVariation', input.value, energyType)
          : setNewEnergyData(solution, otherSystem, 'Price', input.value, energyType);
    }
    checkCustomValue(input);
  }

  function setNewEnergyData(solution, system, dataType, data, changedEnergyType) {
    if (solution[system + 'EnergyTypeInput'].value == changedEnergyType) {
      solution[system + 'Energy' + dataType + 'Input'].value = data;
      checkCustomValue(solution[system + 'Energy' + dataType + 'Input']);
    }
  }

  function getSystemCustomEnergyInfos(solution, system) {
    let energyInfos = {};
    ['efficiency', 'energyPrice', 'energyPriceVariation'].forEach( energyFieldName => {
      const input = solution[system + capitalizeFirstLetter(energyFieldName) + 'Input'];
      if (input.value != input.defaultValue)
        energyInfos['custom' + capitalizeFirstLetter(energyFieldName)] = input.value;
    })
    return energyInfos;
  }

  function getSolutionCustomEnergiesInfos(solution) {
    const energiesInfos = {};
    ['heating', 'hotWater'].forEach( system => {
      energiesInfos[system] = getSystemCustomEnergyInfos(solution, system);
    });
    return energiesInfos;
  }

  function mergeEnergyInfos(system, computedData, customData, isSameSystem) {
    const otherSystem = (system == 'heating') ? 'hotWater' : 'heating';
    ['efficiency', 'energyPrice', 'energyPriceVariation'].forEach( energyFieldName => {
      const customEnergyInfoId = 'custom' + capitalizeFirstLetter(energyFieldName);

      if (customData[customEnergyInfoId])
        computedData[otherSystem][customEnergyInfoId] = customData[customEnergyInfoId];
      if (isSameSystem)
        computedData[system][customEnergyInfoId] = customData[customEnergyInfoId];
    });
    return computedData;
  }

  function mergeSolutionEnergyInfos(computedData, customData) {
    ['heating', 'hotWater'].forEach( system => {
      ['efficiency', 'energyPrice', 'energyPriceVariation'].forEach( energyFieldName => {
        const customEnergyInfoId = 'custom' + capitalizeFirstLetter(energyFieldName);

        if (customData[system][customEnergyInfoId])
          computedData[system][customEnergyInfoId] = customData[system][customEnergyInfoId];
      });
    });
    return computedData;
  }

  function recomputeEnergyInfos(solution) {
    const computedEnergyInfos         = computeSolutionEnergies(solution);
    const customSolutionEnergiesInfos = getSolutionCustomEnergiesInfos(solution);
    const mergedSolutionEnergyInfos   = mergeSolutionEnergyInfos(computedEnergyInfos, customSolutionEnergiesInfos);

    setSolutionEnergyInfos(solution, mergedSolutionEnergyInfos);
  }

  function getSolutionFields(solution) {
    return [
      solution.consideredHeatingSystemSelect,
      solution.heatingEstimatedInvestmentInput,
      solution.heatingEfficiencyInput,
      solution.heatingMaintenanceInput,
      solution.heatingEnergyPriceInput,
      solution.heatingEnergyPriceVariationInput,
      solution.consideredHotWaterSystemSelect,
      solution.hotWaterEstimatedInvestmentInput,
      solution.hotWaterEfficiencyInput,
      solution.hotWaterMaintenanceInput,
      solution.hotWaterEnergyPriceInput,
      solution.hotWaterEnergyPriceVariationInput,
      solution.solarSystemSelect,
      solution.solarPanelSurfaceInput,
      solution.solarEstimatedInvestmentInput,
    ];
  }

  function getHeatingFurtherFields(solution) {
    return heatingFurtherFieldNames.map( heatingFurtherFieldName => solution[heatingFurtherFieldName] );
  }

  function getHotWaterFurtherFields(solution) {
    return hotWaterFurtherFieldNames.map( hotWaterFurtherFieldName => solution[hotWaterFurtherFieldName] );
  }

  function validateOrResetToDefault(input) {
    (input.value.trim() == '')
      ? input.value = input.defaultValue
      : validateField(input);
  }

  function checkCustomValue(input) {
    if (input.type != 'checkbox' ) {
      (input.value == input.defaultValue)
        ? removeClass(input, 'custom-value')
        : addClass(input, 'custom-value');
    }
  }


//------------------------------------------------------------------------------
//  SELECT LISTENER FUNCTIONS
//------------------------------------------------------------------------------

  const selectListeners = {
    energyVector: function() {
      let energyVectorId         = estimateNeedsFields.energyVectorsSelect.value;
      energyVectorUnit.innerHTML = t.datas.energy_vectors[datas.requests.get_energy_vector(energyVectorId).identifier].units;
      estimateNeedsFields.consumptionInput.focus();
    },
    heatingSystem: function(solutionIndex) {
      const solution            = solutions[solutionIndex];
      const heatingFurtherInfos = solution.consideredHeatingSystemSelect.closest('.with-further-infos').querySelector('.further-infos');

      if (solution.consideredHeatingSystemSelect.value !== '') {
        if (validateFields([solution.consideredHeatingSystemSelect, needs.heatingNeedsInput, needs.hotWaterNeedsInput])) {
          checkSolutionErrors(solutionIndex);
          removeClass(heatingFurtherInfos, 'is-hidden');
          // Enabled all heating further fields
          getHeatingFurtherFields(solution).forEach( heatingFurtherField => {
            heatingFurtherField.disabled = false;
          });
          if (needs.hotWaterNeedsInput.value !== '0')
            solution.consideredHotWaterSystemSelect.disabled = false;

          const oldEnergyType = solution.heatingEnergyTypeInput.value;
          const heatingSystem = datas.requests.get_heating_system(solution.consideredHeatingSystemSelect.value);
          const energyType    = datas.requests.get_energy_type_by_id(heatingSystem.energy_type_id);

          // attribute heating system selected values to corresponding fields
          setInputValue(solution.heatingEstimatedInvestmentInput, heatingSystem.investment);
          setInputValue(solution.heatingEfficiencyInput, toFloat(heatingSystem.efficiency * 100));
          setInputValue(solution.heatingMaintenanceInput, heatingSystem.maintenance);
          // Refresh hot water system data if it's the same as heating system
          const isSameSystem = solution.consideredHotWaterSystemSelect.value == '0' || solution.consideredHotWaterSystemSelect.value == solution.consideredHeatingSystemSelect.value;
          if (isSameSystem) {
            const hotWaterSystem = datas.requests.get_hot_water_system(heatingSystem.id);
            const hotWaterInvestment = (isSameSystem)
              ? datas.requests.get_hot_water_system(0).investment
              : hotWaterSystem.investment;
            setInputValue(solution.hotWaterEstimatedInvestmentInput, hotWaterInvestment);
            setInputValue(solution.hotWaterEfficiencyInput, toFloat(hotWaterSystem.efficiency * 100));
            setInputValue(solution.hotWaterMaintenanceInput, 0);
          }

          // show green energy provider if system's energy vector is electricity
          if (energyType.identifier == 'electricity') {
            removeClass(solution.heatingGreenEnergyCheckbox.parentElement, 'is-hidden');
            if (isSameSystem)
              removeClass(solution.hotWaterGreenEnergyCheckbox.parentElement, 'is-hidden');
          } else {
            addClass(solution.heatingGreenEnergyCheckbox.parentElement, 'is-hidden');
            if (isSameSystem)
              addClass(solution.hotWaterGreenEnergyCheckbox.parentElement, 'is-hidden');
          }

          // get modified price variation and energy price from other systems if exists
          //  and merge them to the calulated energy's infos
          if (energyType.identifier != oldEnergyType) {
            const computedEnergyInfos       = computeSolutionEnergies(solution);
            const customHotWaterEnergyInfos = getSystemCustomEnergyInfos(solution, 'hotWater');
            const mergedEnergyInfos         = mergeEnergyInfos('heating', computedEnergyInfos, customHotWaterEnergyInfos, isSameSystem);
            setSolutionEnergyInfos(solution, mergedEnergyInfos);
          }
          solution.heatingEnergyTypeInput.value = energyType.identifier;

          // Validate all heating further fields
          validateFields(getHeatingFurtherFields(solution));
          // Check if heating further fields got custom values
          getHeatingFurtherFields(solution).forEach( heatingFurtherField => {
            checkCustomValue(heatingFurtherField);
          });
          // Check if hotWater further fields got custom values
          if (isSameSystem) {
            getHotWaterFurtherFields(solution).forEach( hotWaterFurtherField => {
              checkCustomValue(hotWaterFurtherField);
            });
          }
        } else { // force needs to be filled
          if (!hasClass(heatingFurtherInfos, 'is-hidden'))
            addClass(heatingFurtherInfos, 'is-hidden');
          scrollToIfNotVisible(document.querySelector('.is-invalid-label').getBoundingClientRect().top);
        }
      }
    },
    hotWaterSystem: function(solutionIndex) {
      const solution             = solutions[solutionIndex];
      const hotWaterFurtherInfos = solution.consideredHotWaterSystemSelect.closest('.with-further-infos').querySelector('.further-infos');

      if (solution.consideredHotWaterSystemSelect.value !== '' && solution.consideredHotWaterSystemSelect.value != -1) {
        if (validateFields([solution.consideredHotWaterSystemSelect, needs.heatingNeedsInput, needs.hotWaterNeedsInput])) {
          checkSolutionErrors(solutionIndex);
          removeClass(hotWaterFurtherInfos, 'is-hidden');
          solution.solarSystemSelect.disabled = false;

          const isSameSystem  = (solution.consideredHotWaterSystemSelect.value == 0 || solution.consideredHotWaterSystemSelect.value == solution.consideredHeatingSystemSelect.value);
          const oldEnergyType = solution.hotWaterEnergyTypeInput.value;
          const heatingSystem = datas.requests.get_heating_system(solution.consideredHeatingSystemSelect.value);

          // Force specific data when hotWaterSystem is the same as the heating system
          let hotWaterSystem  = {};
          if (isSameSystem) {
            hotWaterSystem             = datas.requests.get_hot_water_system(heatingSystem.id);
            hotWaterSystem.investment  = datas.requests.get_hot_water_system(0).investment;
            hotWaterSystem.maintenance = 0;
          } else
            hotWaterSystem = datas.requests.get_hot_water_system(solution.consideredHotWaterSystemSelect.value);

          const energyType = datas.requests.get_energy_type_by_id(hotWaterSystem.energy_type_id);

          // show green energy provider if system's energy vector is electricity
          if (energyType.identifier == 'electricity') {
            removeClass(solution.hotWaterGreenEnergyCheckbox.parentElement, 'is-hidden')
            solution.hotWaterGreenEnergyCheckbox.checked = (isSameSystem)
              ? solution.heatingGreenEnergyCheckbox.checked
              : false;
          } else {
            addClass(solution.hotWaterGreenEnergyCheckbox.parentElement, 'is-hidden');
          }

          // Attribute hot water system selected values to corresponding fields
          setInputValue(solution.hotWaterEstimatedInvestmentInput, hotWaterSystem.investment);
          setInputValue(solution.hotWaterEfficiencyInput, toFloat(hotWaterSystem.efficiency * 100));
          setInputValue(solution.hotWaterMaintenanceInput, hotWaterSystem.maintenance);

          // Get modified price variation and energy price from other systems if exists
          //  and merge them to the calulated energy's infos
          if (energyType.identifier != oldEnergyType) {
            const computedEnergyInfos      = computeSolutionEnergies(solution);
            const customHeatingEnergyInfos = getSystemCustomEnergyInfos(solution, 'heating');
            const mergedEnergyInfos        = mergeEnergyInfos('hotWater', computedEnergyInfos, customHeatingEnergyInfos, isSameSystem);

            setSolutionEnergyInfos(solution, mergedEnergyInfos);
          }
          solution.hotWaterEnergyTypeInput.value = energyType.identifier; //! Don't move me upward

          getHotWaterFurtherFields(solution).forEach( hotWaterFurtherField => {
            checkCustomValue(hotWaterFurtherField);
          });
        } else { // force needs to be filled
          if (!hasClass(hotWaterFurtherInfos, 'is-hidden'))
            addClass(hotWaterFurtherInfos, 'is-hidden');
          scrollToIfNotVisible(document.querySelector('.is-invalid-label').getBoundingClientRect().top);
        }
      } else
        resetHotWaterSection(solution);
    },
    solarSystem: function(solutionIndex) {
      const solution     = solutions[solutionIndex];
      const solarSytemId = solution.solarSystemSelect.value;

      if (solarSytemId !== '') {
        const solarFurtherInfos = solution.solarSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
        removeClass(solarFurtherInfos, 'is-hidden');
        const solarPanelSurface = solution.solarPanelSurfaceInput.value;

        if (solarPanelSurface == '') {
          solution.solarPanelSurfaceInput.focus()
        } else {
          recomputeEnergyInfos(solution);
          setSolarInvestmentInput(solution.solarEstimatedInvestmentInput, solarSytemId, solarPanelSurface);
        }
      } else {
        resetSolarSection(solution);
        recomputeEnergyInfos(solution);
      }
      checkCustomValue(solution.solarEstimatedInvestmentInput);
    }
  };


//------------------------------------------------------------------------------
//  INPUT LISTENER FUNCTIONS
//------------------------------------------------------------------------------

  const inputListeners = {
    furtherInfos: function(input) {
      validateOrResetToDefault(input);
      checkCustomValue(input);
    },
    needs: function(input) {
      const sanitizedValue = parseInt(input.value.trim()); // "020,2" -> "20"
      input.value = (isNaN(sanitizedValue)) ? '' : Math.abs(sanitizedValue);

      if (!validateField(input)) // anticipate validation just to display error message if user focus and blur from the input with a wrong value
        scrollToIfNotVisible(document.querySelector('.is-invalid-label').getBoundingClientRect().top);

      if (oldHotWaterNeedsInput.value != '' || needs.hotWaterNeedsInput.value != '') { // Avoid to display error when user as just filled his heating needs at the beginning
        if (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput])) {
          // Force to recompute and refresh further infos
          for (let i=0; i < solutionsWizard.getNbActiveTabs(); i++) {
            const solution                    = solutions[i];
            const currentHeatingSystemSelect  = solution.consideredHeatingSystemSelect;
            const currentHotWaterSystemSelect = solution.consideredHotWaterSystemSelect;
            const currentSolarSystemSelect    = solution.solarSystemSelect;

            // HEATING REFRESH
            if (currentHeatingSystemSelect.value != '') {
              const heatingFurtherInfos = currentHeatingSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
              if (hasClass(heatingFurtherInfos, 'is-hidden'))
                removeClass(heatingFurtherInfos, 'is-hidden');

              // HOT WATER REFRESH
              if (!['', '-1'].includes(currentHotWaterSystemSelect.value)) {
                const hotWaterFurtherInfos = currentHotWaterSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
                removeClass(hotWaterFurtherInfos, 'is-hidden');
                currentSolarSystemSelect.disabled = false;

                // SOLAR REFRESH
                if (currentSolarSystemSelect.value != '') {
                  const solarFurtherInfos = currentSolarSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
                  removeClass(solarFurtherInfos, 'is-hidden');
                }
              }
              recomputeEnergyInfos(solution);
              checkSolutionErrors(i);
            }
          }
        } else {
          const currentSolution      = solutions[solutionsWizard.getSelectedIndex()];
          const heatingFurtherInfos  = currentSolution.consideredHeatingSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
          const hotWaterFurtherInfos = currentSolution.consideredHotWaterSystemSelect.closest('.with-further-infos').querySelector('.further-infos');
          const solarFurtherInfos    = currentSolution.solarSystemSelect.closest('.with-further-infos').querySelector('.further-infos');

          // disabled them to avoid to have to recompute energy infos for each select for this use case :
          // fill heatingNeeds -> fill hotWaterNeeds -> fill consideredHeatingSystem
          // fill consideredHotWaterSystem -> fill empty hotWaterNeeds -> change consideredHotWaterSystem
          // refill hotWaterNeeds with valid value
          // => need to trigger change event on consideredHotWaterSystem (which recomputeEnergyInfos)
          // and recompute a second time at the end of refresh
          currentSolution.consideredHotWaterSystemSelect.disabled = true;
          currentSolution.solarSystemSelect.disabled              = true;
          addClass(heatingFurtherInfos, 'is-hidden');
          addClass(hotWaterFurtherInfos, 'is-hidden');
          addClass(solarFurtherInfos, 'is-hidden');

          for (let i=0; i < solutionsWizard.getNbActiveTabs(); i++) {
            checkSolutionErrors(i);
          }
          scrollToIfNotVisible(document.querySelector('.is-invalid-label').getBoundingClientRect().top);
        }
      }
    },
    hotWaterNeeds: () => {
      const oldValue = oldHotWaterNeedsInput.value;
      const solutionsTabs = solutionsWizard.getTabs();

      if (needs.hotWaterNeedsInput.value === '0') {
        for (let i=0; i <= solutionsTabs.length - 1; i++) {
          const solution = solutions [i];
          resetHotWaterSection(solution);
          resetSolarSection(solution);
          checkSolutionErrors(i);
        }
        oldHotWaterNeedsInput.value = 0;
      } else {
        if (oldValue === '0' && needs.hotWaterNeedsInput.value != '') {
          for (let i=0; i <= solutionsTabs.length - 1; i++) {
            const solution = solutions[i];

            resetHotWaterSection(solution);
            resetSolarSection(solution);
            solution.consideredHotWaterSystemSelect.disabled = false;

            if (!hasClass(solutionsTabs[i], 'disabled')) {
              if (solution.consideredHeatingSystemSelect.value != '')
                validateField(solution.consideredHotWaterSystemSelect); // Force error to be init
              checkSolutionErrors(i);
            }
          }
        }
        oldHotWaterNeedsInput.value = needs.hotWaterNeedsInput.value;
      }
    },
    energyInputs: function(solutionIndex, system, energyInput){
      const solution = solutions[solutionIndex];

      validateOrResetToDefault(energyInput);
      (validateField(energyInput))
        ? propagateEnergyData(solution, system, energyInput, solution[system + 'EnergyTypeInput'].value)
        : checkSolutionErrors(solutionIndex);
    },
    efficiency: function(solution, input) {
      validateOrResetToDefault(input);
      recomputeEnergyInfos(solution);
      checkCustomValue(input);
    },
    solarPanelSurface: function(solutionIndex) {
      const solution     = solutions[solutionIndex];
      const solarSytemId = solution.solarSystemSelect.value;

      if (solarSytemId !== '' && validateFields([solution.solarPanelSurfaceInput, needs.heatingNeedsInput, needs.hotWaterNeedsInput])) {
        recomputeEnergyInfos(solution);
        setSolarInvestmentInput(solution.solarEstimatedInvestmentInput, solarSytemId, solution.solarPanelSurfaceInput.value);
      } else {
        solution.solarEstimatedInvestmentInput.value    = null;
        solution.solarEstimatedInvestmentInput.disabled = true;
      }
    },
  };

  function setSolarInvestmentInput(solarEstimatedInvestmentInput, solarSytemId, solarPanelSurface) {
    const investmentByM2  = datas.requests.get_solar_system(solarSytemId).investment_by_m2;
    const totalInvestment = compute.solar_total_investment(solarSytemId, solarPanelSurface, investmentByM2);

    setInputValue(solarEstimatedInvestmentInput, totalInvestment);
    removeClass(solarEstimatedInvestmentInput, 'custom-value');
    removeError(solarEstimatedInvestmentInput.closest('label'));
    solarEstimatedInvestmentInput.disabled = false;
  }


//------------------------------------------------------------------------------
//  WIZARD FUNCTIONS
//------------------------------------------------------------------------------

  const solutionsWizard = new Wizard('.js-wizard-tab', '.js-wizard-tab-panel', {
    dataAttr: 'data-wizard-tab-id',
  });

  function bindSolutionsWizardTabs(solutionTab) {
    addClickEventListener(solutionTab, function(event) {
      if (!hasClass(event.currentTarget, 'disabled')) {
        const selectedTabIndex = parseInt(event.currentTarget.getAttribute('data-wizard-tab-id').slice(-1));
        if (validateSolution(solutionsWizard.getSelectedIndex())) {
          solutionsWizard.activate('heating-solution-' + selectedTabIndex);
          handleWizardNavBar(selectedTabIndex - 1);
          scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
        } else {
          scrollToIfNotVisible(document.querySelector('#heating-solutions .is-invalid-label').getBoundingClientRect().top);
        }
      }
    });
  }

  function handleWizardNavBar(step) {
    const nbSteps = solutionsWizard.getTabs().length;

    (step > 0)
      ? removeClass(prevSolutionBtn, 'is-hidden')
      : addClass(prevSolutionBtn, 'is-hidden');

    (solutionsWizard.getNbActiveTabs() <= 1)
      ? addClass(cancelSolutionBtn, 'is-hidden')
      : removeClass(cancelSolutionBtn, 'is-hidden');

    if (solutionsWizard.getNbActiveTabs() < 2) {
      if (!hasClass(compareSolutionsBtn, 'disabled'))
        addClass(compareSolutionsBtn, 'disabled');
    } else {
      if (hasClass(compareSolutionsBtn, 'disabled'))
        removeClass(compareSolutionsBtn, 'disabled');
    }
    (step < nbSteps-1)
      ? removeClass(nextSolutionBtn, 'disabled')
      : addClass(nextSolutionBtn, 'disabled');

    const nextStep = solutionsWizard.getTabs()[step+1];

    nextSolutionBtn.innerHTML = (nextStep != undefined && !hasClass(nextStep, 'disabled'))
      ? t.wizard.next
      : t.wizard.new_solution;
  }

  function previousSolution(currentStep) {
    solutionsWizard.activate('heating-solution-' + currentStep);
    handleWizardNavBar(currentStep-1);
    scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
  }

  function resetFurtherFields(furtherFields) {
    furtherFields.forEach( furtherField => {
      if ((/-green-energy-/i.test(furtherField.id))) {
        furtherField.checked = false;
      } else {
        setInputValue(furtherField, '');
        removeClass(furtherField, 'custom-value');
        removeError(furtherField.closest('label'));
      }
    });
  }

  function resetHeatingSection(solution) {
    const heatingSystemSelect = solution.consideredHeatingSystemSelect;
    const heatingFurtherInfos = heatingSystemSelect.closest('.with-further-infos').querySelector('.further-infos');

    heatingSystemSelect.value             = '';
    solution.heatingEnergyTypeInput.value = '';

    removeError(heatingSystemSelect.closest('label'));
    addClass(heatingFurtherInfos, 'is-hidden');
    resetFurtherFields(getHeatingFurtherFields(solution));
  }

  function resetHotWaterSection(solution) {
    const hotWaterSystemSelect = solution.consideredHotWaterSystemSelect;
    const hotWaterFurtherInfos = hotWaterSystemSelect.closest('.with-further-infos').querySelector('.further-infos');

    populateHotWaterSystemSelect(solution);
    hotWaterSystemSelect.value = (needs.hotWaterNeedsInput.value == 0) ? -1 : '';
    solution.hotWaterEnergyTypeInput.value = '';
    removeError(hotWaterSystemSelect.closest('label'));
    hotWaterSystemSelect.disabled = true;
    addClass(hotWaterFurtherInfos, 'is-hidden');
    resetFurtherFields(getHotWaterFurtherFields(solution));
  }

  function resetSolarSection(solution) {
    solution.solarSystemSelect.value      = '';
    solution.solarSystemSelect.disabled   = ['', '-1'].includes(solution.consideredHotWaterSystemSelect.value);
    solution.solarPanelSurfaceInput.value = '';

    removeError(solution.solarPanelSurfaceInput.closest('label'));
    setInputValue(solution.solarEstimatedInvestmentInput, 0);
    solution.solarEstimatedInvestmentInput.disabled = true;
    removeError(solution.solarEstimatedInvestmentInput.closest('label'));
    removeClass(solution.solarEstimatedInvestmentInput, 'custom-value');
    addClass(solution.solarPanelSurfaceInput.closest('.further-infos'), 'is-hidden');
  }

  function resetSolution(solutionIndex) {
    const solution = solutions[solutionIndex];

    resetHeatingSection(solution);
    resetHotWaterSection(solution);
    resetSolarSection(solution);
    checkSolutionErrors(solutionIndex);
  }

  function duplicateSolution(currentStep) {
    const copiedSolution      = solutions[currentStep+1];
    const overwrittenSolution = solutions[currentStep];

    for (let field in copiedSolution) {
      if (!['heatingEnergyPriceTooltip', 'hotWaterEnergyPriceTooltip'].includes(field)) {
        const overwrittenField = overwrittenSolution[field];
        const copiedField      = copiedSolution[field];

        if (['consideredHeatingSystemSelect', 'consideredHotWaterSystemSelect', 'solarSystemSelect'].includes(field)) {
          duplicateSelect(overwrittenField, copiedField);
        } else if (['heatingGreenEnergyCheckbox', 'hotWaterGreenEnergyCheckbox'].includes(field)) {
          overwrittenField.checked = copiedField.checked;
        } else {
          duplicateInput(overwrittenField, copiedField);
          if (['heatingEnergyTypeInput', 'hotWaterEnergyTypeInput'].includes(field)) {
            const greenEnergySection = (field == 'heatingEnergyTypeInput')
              ? overwrittenSolution['heatingGreenEnergyCheckbox'].parentElement
              : overwrittenSolution['hotWaterGreenEnergyCheckbox'].parentElement;
            (copiedField.value == 'electricity')
              ? removeClass(greenEnergySection, 'is-hidden')
              : addClass(greenEnergySection, 'is-hidden');
          }
        }
        if (hasClass(copiedField, 'is-invalid-input'))
          validateField(overwrittenField);
      }
    }
    recomputeEnergyInfos(overwrittenSolution);
    resetSolution(currentStep+1);
    checkSolutionErrors(currentStep);
  }

  function duplicateSelect(overwrittenSelect, copiedSelect) {
    overwrittenSelect.value    = copiedSelect.value;
    overwrittenSelect.disabled = copiedSelect.disabled;

    const furtherInfos = overwrittenSelect.closest('.with-further-infos').querySelector('.further-infos');
    (['', '-1'].includes(overwrittenSelect.value))
      ? addClass(furtherInfos, 'is-hidden')
      : removeClass(furtherInfos, 'is-hidden');
  }

  function duplicateInput(overwrittenInput, copiedInput) {
    overwrittenInput.value        = copiedInput.value;
    overwrittenInput.defaultValue = copiedInput.defaultValue;
    overwrittenInput.disabled     = copiedInput.disabled;
    checkCustomValue(overwrittenInput);
  }

  function goToPreviousSolution() {
    if (!hasClass(prevSolutionBtn, 'disabled')) {
      const currentStep = solutionsWizard.getSelectedIndex();
      setTimeout( () => { // Avoid to try to validate before onBlur events finish to populate inputs (ex: solarPanelSurface)
        (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput]) && validateSolution(currentStep))
          ? previousSolution(currentStep)
          : scrollToIfNotVisible(document.querySelector('#simulations .is-invalid-label').getBoundingClientRect().top);
      }, 10);
    }
  }

  function goToNextSolution() {
    const currentStep = solutionsWizard.getSelectedIndex();

    setTimeout( () => { // Avoid to try to validate before onBlur events finish to populate inputs (ex: solarPanelSurface)
      if (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput]) && validateSolution(currentStep)) {
        solutionsWizard.activate('heating-solution-' + (currentStep + 2));
        handleWizardNavBar(currentStep+1);
        scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
      } else
        scrollToIfNotVisible(document.querySelector('#simulations .is-invalid-label').getBoundingClientRect().top);
    }, 10);
  }

  function compareSolutions() {
    setTimeout( () => { // Avoid to try to validate before onBlur events finish to populate inputs (ex: solarPanelSurface)
      if (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput]) && validateSolution(solutionsWizard.getSelectedIndex())) {
        let errorInAnotherSolution = false;
        for (let i=0; i < solutionsWizard.getNbActiveTabs(); i++ ) {
          if (!validateSolution(i)) {
            solutionsWizard.activate('heating-solution-' + (i+1));
            handleWizardNavBar(i);
            scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
            errorInAnotherSolution = true;
            break;
          }
        }
        if (!errorInAnotherSolution) {
          showLoadingDimmer(true, t.dimmer.computing);
          setTimeout( () => {
            computeScenariiResults();
            resetFlippedCards();
            setResultActiveScenarioTab();
            showLoadingDimmer(false);
            mainSteps.activate('results', {
              after: () => {
                scrollTo(document.querySelector('header').getBoundingClientRect().top);
              }
            });
          }, 10);
        }
      } else
        scrollToIfNotVisible(document.querySelector('#simulations .is-invalid-label').getBoundingClientRect().top);
    }, 10);
  }

  function getSolutionValues(solution) {
    const solarPanelSurface        = solution.solarPanelSurfaceInput.value;
    const solarEstimatedInvestment = solution.solarEstimatedInvestmentInput.value;

    return {
      heating: {
        needs                : Math.abs(parseInt(needs.heatingNeedsInput.value)),
        systemId             : solution.consideredHeatingSystemSelect.value,
        greenEnergy          : solution.heatingGreenEnergyCheckbox.checked,
        estimatedInvestment  : toFloat(solution.heatingEstimatedInvestmentInput.value),
        efficiency           : toFloat((solution.heatingEfficiencyInput.value / 100), 4),
        maintenance          : toFloat(solution.heatingMaintenanceInput.value),
        energyPrice          : toFloat(solution.heatingEnergyPriceInput.value),
        energyPriceVariation : toFloat((solution.heatingEnergyPriceVariationInput.value / 100), 4),
      },
      hotWater: {
        needs                : Math.abs(parseInt(needs.hotWaterNeedsInput.value)),
        systemId             : solution.consideredHotWaterSystemSelect.value,
        greenEnergy          : solution.hotWaterGreenEnergyCheckbox.checked,
        estimatedInvestment  : toFloat(solution.hotWaterEstimatedInvestmentInput.value),
        efficiency           : toFloat((solution.hotWaterEfficiencyInput.value / 100), 4),
        maintenance          : toFloat(solution.hotWaterMaintenanceInput.value),
        energyPrice          : toFloat(solution.hotWaterEnergyPriceInput.value),
        energyPriceVariation : toFloat((solution.hotWaterEnergyPriceVariationInput.value / 100), 4),
      },
      solar: {
        systemId             : solution.solarSystemSelect.value,
        panelSurface         : (solarPanelSurface == '') ? 0 : parseInt(solarPanelSurface),
        estimatedInvestment  : (solarEstimatedInvestment == '') ? 0 : parseInt(solarEstimatedInvestment),
      },
    };
  }


  //----------------------------------------------------------------------------
  //  LISTENERS
  //----------------------------------------------------------------------------

  [needs.heatingNeedsInput, needs.hotWaterNeedsInput].forEach( input => {
    input.addEventListener('blur', event => {
      inputListeners.needs(input);
    });
  });

  needs.hotWaterNeedsInput.addEventListener('blur', function(event) {
    inputListeners.hotWaterNeeds();
  });

  solutionsWizard.getTabs().forEach ( solutionTab => {
    bindSolutionsWizardTabs(solutionTab);
  });

  addClickEventListener(cancelSolutionBtn, function(event) {
    if (validateFields([needs.heatingNeedsInput, needs.hotWaterNeedsInput])) {
      const currentStep = solutionsWizard.getSelectedIndex();
      if (currentStep >= 0) {
        const steps = solutionsWizard.getTabs();
        const nbActiveTabs = solutionsWizard.getNbActiveTabs();
        if (currentStep >= (steps.length - 1) || currentStep == (nbActiveTabs - 1)) {
          resetSolution(currentStep);
          addClass(steps[currentStep], 'disabled');
          previousSolution(currentStep);
        } else {
          for (let i = currentStep; i < (nbActiveTabs - 1); i++) {
            duplicateSolution(i);
          }
          addClass(solutionsWizard.getTabs()[nbActiveTabs - 1], 'disabled');
          handleWizardNavBar(currentStep);
          scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
        }
      }
    } else
      scrollToIfNotVisible(document.querySelector('.is-invalid-label').getBoundingClientRect().top);
  });

  addClickEventListener(resetSolutionBtn, function(event) {
    const currentStep = solutionsWizard.getSelectedIndex();
    resetSolution(currentStep);
    scrollTo(heatingSolutionsTitle.getBoundingClientRect().top);
  });

  addClickEventListener(prevSolutionBtn, goToPreviousSolution);

  addClickEventListener(nextSolutionBtn, goToNextSolution);

  // // First draft of a swipe handler for the Wizard
  //
  // [].forEach.call(document.getElementsByClassName('js-wizard-tab-panel'), (wizardPanel) => {
  //   wizardPanel.addEventListener('touchstart', event => {
  //     xDown = event.touches[0].clientX;
  //   }, false);
  //   wizardPanel.addEventListener('touchmove', handleTouchMove, false);
  // })
  //
  // let xDown = null;
  //
  // function handleTouchMove(event) {
  //     if (!xDown) return;
  //     const xUp   = event.touches[0].clientX;
  //     const yUp   = event.touches[0].clientY;
  //     const xDiff = xDown - xUp;
  //
  //     if (xDiff > 10) goToPreviousSolution(); // Left swipe
  //     if (xDiff < -10) console.log('RIGHT SWIPE'); //Right swipe
  //
  //     xDown = null;
  // };

  solutions.forEach( (solution, index) => {

    solution.consideredHeatingSystemSelect.addEventListener('change', function(event) {
      selectListeners.heatingSystem(index);
    });

    solution.consideredHotWaterSystemSelect.addEventListener('change', function(event) {
      selectListeners.hotWaterSystem(index);
    });

    solution.solarSystemSelect.addEventListener('change', function() {
      selectListeners.solarSystem(index);
    });

    solution.heatingGreenEnergyCheckbox.addEventListener('change', function(event) {
      // link hot water green energy checkbox to the state of the heating system
      //  green energy checkbox because we can't have two different electricity providers
      if (solution.hotWaterEnergyTypeInput.value == 'electricity')
        solution.hotWaterGreenEnergyCheckbox.checked = this.checked;
      setGreenElectricityData(index, 'heating');
    });

    solution.hotWaterGreenEnergyCheckbox.addEventListener('change', function(event) {
      if (solution.hotWaterEnergyTypeInput.value == 'electricity')
        solution.heatingGreenEnergyCheckbox.checked = this.checked;
      setGreenElectricityData(index, 'hotWater');
    });

    // PRICE + PRICE VARIATION
    ['heating', 'hotWater'].forEach( system => {
      ['EnergyPriceInput', 'EnergyPriceVariationInput'].forEach( inputType => {
        const energyInput = solution[system + inputType];

        energyInput.addEventListener('blur', function(event) {
          inputListeners.energyInputs(index, system, energyInput);
        });
      });
    });

    // EFFICIENCY
    ['heating', 'hotWater'].forEach( system => {
      const efficiencyInput = solution[system + 'EfficiencyInput'];

      efficiencyInput.addEventListener('blur', function(event) {
        inputListeners.efficiency(solution, efficiencyInput);
      });
    });

    solution.solarPanelSurfaceInput.addEventListener('change', function(event) {
      inputListeners.solarPanelSurface(index);
    });

    [ solution.solarEstimatedInvestmentInput,
      solution.heatingEstimatedInvestmentInput,
      solution.heatingMaintenanceInput,
      solution.hotWaterEstimatedInvestmentInput,
      solution.hotWaterMaintenanceInput,
    ].forEach( input => {
      input.addEventListener('blur', function(event) {
        inputListeners.furtherInfos(input);
      });
    });

    getSolutionFields(solution).forEach( input => {
      input.addEventListener('blur', function(event) {
        checkSolutionErrors(index);
      });
    });

  }); // end each solutions


  //----------------------------------------------------------------------------
  //  SUBMIT BUTTONS
  //----------------------------------------------------------------------------

  addClickEventListener(compareSolutionsBtn, function(event) {
    if (!hasClass(compareSolutionsBtn, 'disabled'))
      compareSolutions();
  });

  /**
   * Apply all fields validations
   *
   * @param  {object}  solution - Collection of solution's inputs
   * @return {boolean}          - Return true if all validations passed, false instead
   */
  function validateSolution(solutionIndex) {
    const solution = solutions[solutionIndex];

    let fieldsToValidate = [
      solution.consideredHeatingSystemSelect,
    ];
    if (needs.hotWaterNeedsInput.value > 0)
      fieldsToValidate.push(solution.consideredHotWaterSystemSelect);

    if (solution.consideredHeatingSystemSelect.value !== '') {
      fieldsToValidate = fieldsToValidate.concat([
        solution.heatingEstimatedInvestmentInput,
        solution.heatingEfficiencyInput,
        solution.heatingMaintenanceInput,
        solution.heatingEnergyPriceInput,
        solution.heatingEnergyPriceVariationInput,
      ]);
    }

    if (!['', '-1'].includes(solution.consideredHotWaterSystemSelect.value)) {
      fieldsToValidate = fieldsToValidate.concat([
        solution.hotWaterEstimatedInvestmentInput,
        solution.hotWaterEfficiencyInput,
        solution.hotWaterMaintenanceInput,
        solution.hotWaterEnergyPriceInput,
        solution.hotWaterEnergyPriceVariationInput
      ]);
    }
    if (solution.solarSystemSelect.value !== '') {
      fieldsToValidate = fieldsToValidate.concat([
        solution.solarPanelSurfaceInput,
        solution.solarEstimatedInvestmentInput
      ]);
    }
    const fieldsValid = validateFields(fieldsToValidate);
    checkSolutionErrors(solutionIndex);
    // if (estimatedInvestment !== '' || estimatedInvestment !== undefined || estimatedInvestment !== null)
    return fieldsValid;
  }


//================================================================================
//                            EXAMPLE SIMULATION
//================================================================================

  function populateWithExampleSimulation() {
    (example.estimateNeedsFields)
      ? populateEstimateNeeds(example.estimateNeedsFields)
      : populateNeeds(example.needs);

    const solutionTabs = solutionsWizard.getTabs();

    for (let i = 0; i < nbMaxSolutions; i++) {
      const exampleSolutionData = example.solutions[i];

      if (exampleSolutionData) {
        removeClass(solutionTabs[i], 'disabled');
        populateSolution(i, exampleSolutionData);
      } else {
        resetSolution(i);
        addClass(solutionTabs[i], 'disabled');
      }
    }

    handleWizardNavBar(0);
    if (mainSteps.getSelectedIndex() !== 0) {
      mainSteps.activate('simulations', {
        after: () => {
          scrollTo(document.querySelector('header').getBoundingClientRect().top);
        }
      });
    }
  }

  /**
   * Populate the estimate my needs modal and simulation needs fields
   *
   * @param {hash} exampleNeeds
   */
  function populateEstimateNeeds(exampleNeeds) {
    estimateNeedsFields.livingAreaInput.value  = exampleNeeds.livingAreaInput;
    estimateNeedsFields.inhabitantsInput.value = exampleNeeds.inhabitantsInput;
    const estimateFromRadio   = document.getElementById('estimate-from-' + exampleNeeds.estimateFromRadio)
    estimateFromRadio.checked = true;
    estimateFromRadioTabs.activate('estimate-from-' + exampleNeeds.estimateFromRadio);
    document.querySelector('.js-estimate-from-panel.active').getAttribute('data-radio-tab-id')

    if (exampleNeeds.estimateFromRadio == 'invoices')
      estimateNeedsFields.invoicesTextArea.value = exampleNeeds.invoicesTextArea;

    if (exampleNeeds.estimateFromRadio == 'building_years')
      estimateNeedsFields.buildingYearsSelect.value = exampleNeeds.buildingYearsSelect;

    if (exampleNeeds.estimateFromRadio == 'consumption') {
      estimateNeedsFields.energyVectorsSelect.value = exampleNeeds.energyVectorsSelect;
      selectListeners.energyVector();
      estimateNeedsFields.consumptionInput.value = exampleNeeds.consumptionInput;
    }
    if (['invoices', 'consumption'].includes(exampleNeeds.estimateFromRadio)) {
      estimateNeedsFields.currentHeatingSystemSelect.value  = exampleNeeds.currentHeatingSystemSelect;
      estimateNeedsFields.currentHotWaterSystemSelect.value = exampleNeeds.currentHotWaterSystemSelect;
    }

    estimateMyNeeds();
    validAndPopulateEstimatedNeeds();
  }

  /**
   * Populate directly the needs fields
   *
   * @param {hash} exampleNeeds
   */
  function populateNeeds(exampleNeeds) {
    needs.heatingNeedsInput.value  = exampleNeeds.heatingNeedsInput;
    needs.hotWaterNeedsInput.value = exampleNeeds.hotWaterNeedsInput;
  }

  /**
   * Populate the solutions panels
   *
   * @param {integer} solutionIndex
   * @param {hash}    solution
   * @param {hash}    exampleSolution
   */
  function populateSolution(solutionIndex, exampleSolution) {
    const solution = solutions[solutionIndex];

    // HEATING
    resetHeatingSection(solution);
    solution.consideredHeatingSystemSelect.value = exampleSolution.consideredHeatingSystemSelect;
    selectListeners.heatingSystem(solutionIndex);

    heatingFurtherFieldNames.forEach( heatingFurtherFieldName => {
      if (exampleSolution[heatingFurtherFieldName]) {
        const input = solution[heatingFurtherFieldName];
        input.value = exampleSolution[heatingFurtherFieldName];

        dispatchEventForFurtherFields(solutionIndex, 'heating', heatingFurtherFieldName, input);
      }
    });
    // HOT WATER
    resetHotWaterSection(solution);
    if (exampleSolution.consideredHotWaterSystemSelect !== '') {
      solution.consideredHotWaterSystemSelect.value = exampleSolution.consideredHotWaterSystemSelect;
      selectListeners.hotWaterSystem(solutionIndex);

      hotWaterFurtherFieldNames.forEach( hotWaterFurtherFieldName => {
        if (exampleSolution[hotWaterFurtherFieldName]) {
          const input = solution[hotWaterFurtherFieldName];
          input.value = exampleSolution[hotWaterFurtherFieldName];
          dispatchEventForFurtherFields(solutionIndex, 'hotWater', hotWaterFurtherFieldName, input);
        }
      });
    }
    // SOLAR
    resetSolarSection(solution);
    if (exampleSolution.solarSystemSelect !== '') {
      solution.solarSystemSelect.value = exampleSolution.solarSystemSelect;
      selectListeners.solarSystem(solutionIndex);

      if (exampleSolution.solarPanelSurfaceInput) {
        solution.solarPanelSurfaceInput.value = exampleSolution.solarPanelSurfaceInput;
        inputListeners.solarPanelSurface(solutionIndex);
      }
      if (exampleSolution.solarEstimatedInvestmentInput)
        solution.solarEstimatedInvestmentInput.value = exampleSolution.solarEstimatedInvestmentInput;
    }

    if (needs.hotWaterNeedsInput.value !== '0') {
      solution.consideredHotWaterSystemSelect.disabled = false;
      solution.solarSystemSelect.disabled              = false;
    }
  }
  /**
   * Dispatch the event for a specific solution system further fields
   *
   * @param {hash}        solution
   * @param {string}      system
   * @param {string}      furtherFieldName
   * @param {NodeElement} input
   */
  function dispatchEventForFurtherFields(solutionIndex, system, furtherFieldName, input) {
    const solution = solutions[solutionIndex];

    switch (furtherFieldName) {
      case (system + 'EfficiencyInput'):
        inputListeners.efficiency(solution, input);
        break;
      case (system + 'EnergyPriceInput'):
      case (system + 'EnergyPriceVariationInput'):
        inputListeners.energyInputs(solution, 'heating', input);
        break;
      default:
        inputListeners.furtherInfos(input);
    }
  }


//================================================================================
//                                 RESULTS
//================================================================================

  function resetFlippedCards() {
    [].forEach.call(flipCards, flipCard => {
      if (hasClass(flipCard, 'flipped')) removeClass(flipCard, 'flipped');
    });
  }

  // Initialize results tabs [trend-scenario, crysis-scenario, custom-scenario]
  const scenariiTabs  = new Tabs('.js-scenarii-tab', '.js-scenarii-tab-panel', { tabActiveClass: 'bt-active'});
  let scenariiResults = {};

  function computeScenariiResults() {
    scenariiResults = {}; // clean old results;
    solutions.forEach( (solution, index) => {
      if (!hasClass(solutionsWizard.getTabs()[index], 'disabled')) {

        const values      = getSolutionValues(solution);
        const energies    = compute.solution.energies(values);
        const solarSystem = compute.solution.solar(values, energies);

        scenarii.forEach( scenario => {
          scenariiResults[scenario] = scenariiResults[scenario] || {};

          scenariiResults[scenario].values = scenariiResults[scenario].values || [];
          scenariiResults[scenario].values.push(values);

          const heatingSystem  = compute.solution.heating(scenario, values, energies);
          const hotWaterSystem = compute.solution.hot_water(scenario, values, energies);
          const completeLabels = buildLabels(values, heatingSystem, hotWaterSystem, solarSystem);

          scenariiResults[scenario].computedDatas = scenariiResults[scenario].computedDatas || [];
          scenariiResults[scenario].computedDatas.push({
            heatingSystem  : heatingSystem,
            hotWaterSystem : hotWaterSystem,
            solarSystem    : solarSystem,
          })

          scenariiResults[scenario].enrProdRatios = scenariiResults[scenario].enrProdRatios || [];
          const enrProdRatio = compute.solution.enr_prod_ratio(values, heatingSystem, hotWaterSystem, solarSystem);
          scenariiResults[scenario].enrProdRatios.push(enrProdRatio);

          // Period Total Cost
          scenariiResults[scenario].periodTotalCost = scenariiResults[scenario].periodTotalCost || {};
          scenariiResults[scenario].periodTotalCost.computedDatas = scenariiResults[scenario].periodTotalCost.computedDatas || [];
          scenariiResults[scenario].periodTotalCost.computedDatas.push(
            compute.solution.period_total_cost({
              label          : completeLabels.short,
              heatingSystem  : heatingSystem,
              hotWaterSystem : hotWaterSystem,
              solarSystem    : solarSystem,
              enrProdRatio   : enrProdRatio,
            })
          );

          // Period Cost Evolution
          scenariiResults[scenario].periodCostEvolution = scenariiResults[scenario].periodCostEvolution || {};
          scenariiResults[scenario].periodCostEvolution.computedDatas = scenariiResults[scenario].periodCostEvolution.computedDatas || [];
          scenariiResults[scenario].periodCostEvolution.computedDatas.push(
            compute.solution.period_cost_evolution({
              label          : completeLabels.short,
              heatingSystem  : heatingSystem,
              hotWaterSystem : hotWaterSystem,
              solarSystem    : solarSystem,
              enrProdRatio   : enrProdRatio,
            })
          );

          // Environmental Impact
          scenariiResults[scenario].environmentalImpact = scenariiResults[scenario].environmentalImpact || {};
          scenariiResults[scenario].environmentalImpact.computedDatas = scenariiResults[scenario].environmentalImpact.computedDatas || [];
          scenariiResults[scenario].environmentalImpact.computedDatas.push(
            compute.solution.environmental_impact({
              label          : completeLabels.short,
              heatingSystem  : heatingSystem,
              hotWaterSystem : hotWaterSystem,
            })
          );
        });
      }
    });
    setOrUpdateCards(scenariiResults);
  };

  // Init scenarii charts
  let scenariiCharts = {};
  // Generate the energies price variations charts because they don't depend on solutions parameters (past values)
  scenarii.forEach( scenario => {
    scenariiCharts[scenario] = scenariiCharts[scenario] || {};
    scenariiCharts[scenario].energiesPriceVariations = charts.energiesPriceVariations(scenario, compute.solution.energies_price_variations_before(scenario));
  });

  function setOrUpdateCards(scenariiResults) {
    scenarii.forEach( scenario => {
      scenariiResults[scenario].savings            = setConclusion(scenario, scenariiResults[scenario]);
      scenariiCharts[scenario].periodTotalCost     = charts.periodTotalCost(scenario, scenariiResults[scenario].periodTotalCost.computedDatas);
      scenariiCharts[scenario].periodCostEvolution = charts.periodCostEvolution(scenario, scenariiResults[scenario].periodCostEvolution.computedDatas);
      scenariiCharts[scenario].environmentalImpact = charts.environmentalImpact(scenario, scenariiResults[scenario].environmentalImpact.computedDatas);
    });

    // Display or hide the solar explanation in the back of the period_total_cost card
    const nbSolarSystemsSelected = solutions.reduce( (acc, solution) => {
      return (solution.solarSystemSelect.value == '') ? acc : acc + 1;
    }, 0);

    [].forEach.call(document.getElementsByClassName('solar_explanation'), solarExplanation => {
      if (nbSolarSystemsSelected > 0 && hasClass(solarExplanation, 'is-hidden'))
        removeClass(solarExplanation, 'is-hidden');
      if (nbSolarSystemsSelected == 0 && !hasClass(solarExplanation, 'is-hidden'))
        addClass(solarExplanation, 'is-hidden');
    });
  }

  /**
   * Build charts labels
   * NOTE : Concatenate raw and styled label because of limitation of highcharts exporter
   *
   * @param  {object} values
   * @param  {object} heatingSystem
   * @param  {object} hotWaterSystem
   * @param  {object} solarSystem
   * @return {object} long  - long label
   *                  short - long short
   */
  function buildLabels(values, heatingSystem, hotWaterSystem, solarSystem) {
    let long     = '<b>' + t.datas.heating_systems[heatingSystem.datas.identifier].long + '</b>';
    let longRaw  = t.datas.heating_systems[heatingSystem.datas.identifier].long;
    let short    = '<b>' + t.datas.heating_systems[heatingSystem.datas.identifier].short + '</b>';
    let shortRaw = t.datas.heating_systems[heatingSystem.datas.identifier].short;
    if (hotWaterSystem.datas.id != 0 && hotWaterSystem.datas.id != heatingSystem.datas.id ) {
      long     += '<br/>' + t.charts.label.ecs + ' : <b>' + t.datas.hot_water_systems[hotWaterSystem.datas.identifier].long + '</b>';
      longRaw  += '<br/>' + t.charts.label.ecs + ' : ' + t.datas.hot_water_systems[hotWaterSystem.datas.identifier].long;
      short    += '<br/>' + t.charts.label.ecs + ' : <b>' + t.datas.hot_water_systems[hotWaterSystem.datas.identifier].short + '</b>';
      shortRaw += '<br/>' + t.charts.label.ecs + ' : ' + t.datas.hot_water_systems[hotWaterSystem.datas.identifier].short;
    }
    if (values.solar.systemId != '') {
      long     += '<br/>' + t.charts.label.solar + ' : <b>' + t.datas.solar_systems[solarSystem.datas.identifier].long + '</b>';
      longRaw  += '<br/>' + t.charts.label.solar + ' : <b>' + t.datas.solar_systems[solarSystem.datas.identifier].long;
      short    += '<br/>' + t.charts.label.solar + ' : <b>' + t.datas.solar_systems[solarSystem.datas.identifier].short + '</b>';
      shortRaw += '<br/>' + t.charts.label.solar + ' : ' + t.datas.solar_systems[solarSystem.datas.identifier].short;
    }

    return {
      long  : longRaw + '|' + long,
      short : shortRaw + '|' + short,
    };
  }

  /**
   * Set Text and Smiley of the "savings" card
   *
   * @param  {string} scenario
   * @param  {object} scenarioResults
   * @return {object} smiley       - smiley identifier
   *                  conclusionId - conclusion identifier
   */
  function setConclusion(scenario, scenarioResults) {
    let enrs   = [];
    let noEnrs = [];
    scenarioResults.enrProdRatios.forEach( (enrProdRatio, i) => {
      const totalCost = scenarioResults.periodTotalCost.computedDatas[i].periodTotalCost;
      (enrProdRatio >= 0.5)
        ? enrs.push(totalCost)
        : noEnrs.push(totalCost);
    });
    let smiley       = 'wondering';
    let conclusionId = 'enr_more_expensive';
    if (enrs.length == 0) {
      conclusionId = 'no_enr';
    } else if (noEnrs.length == 0) {
      smiley       = 'overjoyed';
      conclusionId = 'only_enr';
    } else {
      const cheaperNoEnr = getCheaper(noEnrs);
      const cheaperEnr = getCheaper(enrs);
      enrs.every( enr => {
        if (cheaperEnr < cheaperNoEnr * 0.9) {
          smiley       = 'overjoyed';
          conclusionId = 'enr_cheaper';
        } else if (conclusionId != 'enr_cheaper' && cheaperEnr >= cheaperNoEnr * 0.9 && cheaperEnr <= cheaperNoEnr * 1.0) {
          smiley       = 'overjoyed';
          conclusionId = 'enr_little_cheaper';
        } else if (conclusionId == 'enr_more_expensive' && cheaperEnr > cheaperNoEnr * 1.0 && cheaperEnr <= cheaperNoEnr * 1.1) {
          smiley       = 'happy';
          conclusionId = 'enr_little_more_expensive';
        }
      });
    }
    const smileyIcon          = document.querySelector('#' + scenario + '-savings-icon i');
    smileyIcon.className      = "icon-smiley-" + smiley;

    const savingText          = document.getElementById(scenario + '-savings-text');
    savingText.innerHTML      = t.conclusion[conclusionId];
    savingText.style.fontSize = (['enr_more_expensive', 'only_enr'].includes(conclusionId)) ? '1.2rem' : '1.375rem';

    return {
      smiley       : smiley,
      conclusionId : conclusionId,
    };
  }

  function getCheaper(collection) {
    return collection.reduce(function (p, v) {
      return ( p < v ? p : v );
    });
  }

  function setResultActiveScenarioTab() {
    (document.querySelectorAll('#heating-solutions .custom-value').length > 0)
      ? scenariiTabs.activate('custom-scenario')
      : scenariiTabs.activate('trend-scenario');
  }


  //----------------------------------------------------------------------------
  //  INIT CARDS & PDF BUTTONS
  //----------------------------------------------------------------------------

  // Triggering change event on consumption select to initiate the right units label to the input
  selectListeners.energyVector();

  // Attach click event to flip card
  [].forEach.call(document.getElementsByClassName('js-flip-card'), flipCard => {
    addClickEventListener(flipCard, function() {
      toggleClass(flipCard, 'flipped');
    });
  });

  // Avoid card flipping when clicking on a chart's zone
  [].forEach.call(document.getElementsByClassName('chart'), chartContainer => {
    addClickEventListener(chartContainer, function() {})
  });

  Object.keys(pdfLinks).forEach( scenario => {
    addClickEventListener(pdfLinks[scenario], function() {
      showLoadingDimmer(true, t.dimmer.generate_pdf);
      setTimeout( () => {
        createPdf({
          scenario        : scenario,
          partnerLogos    : partnerLogos,
          needs           : needs,
          scenarioResults : scenariiResults[scenario],
          charts          : scenariiCharts[scenario],
        });
        showLoadingDimmer(false);
      }, 10);
    });
  });
});



// WEBPACK FOOTER //
// ./assets/javascripts/app.js